import { render, staticRenderFns } from "./RegisterFieldDialog.vue?vue&type=template&id=dcca4a36&scoped=true&"
import script from "./RegisterFieldDialog.vue?vue&type=script&lang=js&"
export * from "./RegisterFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFieldDialog.vue?vue&type=style&index=0&id=dcca4a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcca4a36",
  null
  
)

export default component.exports